export const SOCKET_EVENTS = {
  // Connection
  JOIN_SESSION: "join-session",
  LEAVE_SESSION: "leave-session",

  // Messages
  SEND_MESSAGE: "send-message",
  NEW_MESSAGE: "new-message",

  // Typing
  TYPING_START: "typing-start",
  TYPING_STOP: "typing-stop",

  // Read receipts
  MARK_READ: "mark-read",
  MESSAGES_READ: "messages-read",

  // Admin presence
  ADMIN_ONLINE: "admin-online",
  ADMIN_OFFLINE: "admin-offline",
  ADMIN_PRESENCE: "admin-presence",

  // Session updates
  SESSION_UPDATED: "session-updated",

  // Visitor presence
  VISITOR_ONLINE: "visitor-online",
  VISITOR_OFFLINE: "visitor-offline",
} as const;

export type SocketEvent = (typeof SOCKET_EVENTS)[keyof typeof SOCKET_EVENTS];
